<template>
  <div class="prevent-select ">
    <right-panel
      v-if="!hideCreateButton"
      class="float-right  mb-2 mr-2"
      id="sidebar-new-organization"
      width="600px"
      :icon="'mdi mdi-plus mr-1'"
      :text="$t('organization.new')"
      @hidden="rightPanelClosed"
    >
      <div class="pl-2 pr-2">
        <Form :hide-library="true" />
      </div>
    </right-panel>
    <div class="col-sm-4">
      <div class="search-box mr-2 mb-2 d-inline-block">
        <div class="position-relative">
          <input v-model="nameFilter" type="text" class="form-control" placeholder="Ara..." />
          <i class="bx bx-search-alt search-icon"></i>
        </div>
      </div>
    </div>
    <div>
      {{ $t("pages.record-counts-per-page") }}:
      <select v-model="paginationPageSize" class=" ml-2">
        <option value="5" selected>5</option>
        <option value="7">7</option>
        <option value="10">10</option>
        <option value="15">15</option>
      </select>
    </div>

    <div style="clear:both"></div>

    <div class="table-responsive mb-5 pb-5" v-if="pagination && pagination.docs.length > 0">
      <table class="table table-centered table-nowrap">
        <thead class="thead-light">
          <tr>
            <th style="width: 50px;"></th>
            <th scope="col" style="width:200px">
              <sortable-table-head field="name" :text="$t('organization.name')" tag="span" :request="request" />
            </th>
            <th>{{ $t("workspace.name") }}</th>
            <th>{{ $t("common.owner") }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="data in pagination.docs" :key="data._id">
            <td v-if="!data.isDeleting">
              <letter-avatar :name="data.name" :image="data.logo" variant="secondary" />
            </td>
            <td v-else>
              <i class="mdi mdi-progress-close text-danger " style="font-size: 30px;" :title="$t('common.is-deleting')"> </i>
            </td>
            <td>
              <div
                v-b-popover.hover.left="{
                  variant: 'info',
                  html: true,
                  content: data.roles.map((x) => '-' + $options.filters.translate(x.name)).join('<br>'),
                }"
                :title="'<i class=\'bx bxs-user-circle mr-1\'></i>' + $t('role.in-organization')"
              >
                {{ data.name }}
              </div>
            </td>
            <td><i class="mdi mdi-hexagon-multiple-outline"></i> {{ data.workspace.name }}</td>
            <td class="text-muted">{{ data.createdBy.name }}</td>
            <td>
              <template v-if="hideCreateButton">
                <span v-if="selected && selected._id == data._id" class="badge badge-pill badge-soft-success p-2">
                  <i class="bx bxs-pin"></i> {{ $t("organization.selected") }}
                </span>

                <b-button v-b-tooltip.hover :title="$t('organization.switch')" v-else variant="white" @click="$emit('setSelected', data)" :disabled="data.isDeleting">
                  <i class="bx bx-git-compare font-size-18"></i>
                </b-button>
              </template>

              <b-dropdown v-if="!hideCreateButton" size="sm" class="card-drop" dropleft variant="white" :disabled="data.isDeleting">
                <template v-slot:button-content>
                  <i class="mdi mdi-dots-horizontal font-size-17"></i>
                </template>

                <b-dropdown-item-button @click="edit(data)">
                  <i class="bx bx-edit-alt text-warning"></i>
                  {{ $t("common.edit") }}
                </b-dropdown-item-button>

                <b-dropdown-item-button @click="goToMembers(data)">
                  <i class="bx bx-user-circle text-dark"></i>
                  {{ $t("organization.members.text") }}
                </b-dropdown-item-button>

                <b-dropdown-divider></b-dropdown-divider>

                <b-dropdown-item-button @click="deleteById(data._id)">
                  <i class="bx bx-trash-alt text-danger"></i>
                  {{ $t("common.delete") }}
                </b-dropdown-item-button>
              </b-dropdown>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <empty v-else>
      <h5 class="text-center">
        {{ $t("common.not-found") }}
      </h5>
    </empty>

    <template v-if="pagination">
      <div class="d-flex justify-content-center my-3">
        <ul class="pagination pagination-rounded mb-0">
          <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" @click.native.stop size="sm"></b-pagination>
        </ul>
      </div>
    </template>
  </div>
</template>
<script>
import Form from "./organization-form";

export default {
  props: { hideCreateButton: { type: Boolean } },
  components: { Form },

  data() {
    return {
      request: {
        options: { page: 1, limit: 5, sort: { name: "asc" } },
        query: {},
      },
      nameFilter: undefined,
      paginationPageSize: 5,
    };
  },
  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },

    paginationPageSize(v) {
      this.request.options = {
        ...this.request.options,
        limit: v,
        page: 1,
      };
    },
    nameFilter(n) {
      this.request.query = {
        ...this.request.query,
        name: { value: n },
      };
    },
  },

  computed: {
    pagination() {
      return this.$store.getters["organization/pagination"];
    },
    loading() {},
    selected() {
      return this.$store.getters["organization/selected"];
    },
  },

  methods: {
    paginate() {
      this.$store.dispatch(`organization/paginate`, this.request);
    },

    edit(data) {
      this.$store.commit("organization/editedOrganization", data);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-organization");
    },

    goToMembers(data) {
      this.$store.dispatch("organization/selected", data);
      window.location = "/organization/members";
    },
    async deleteById(id) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("organization/delete", id);
        this.paginate();
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    rightPanelClosed() {
      this.$store.commit("organization/editedOrganization", null);
      this.paginate();
    },
  },
};
</script>
